  <!-- Partie superieur avec mes mails et la barre de recherche -->
  
  <div class="row justify-content-md-center en-tête pb-1 m-0" style="min-height: 5vh;" *ngIf="appareilName == 'emprunts'">
    <h5 class="col-12 text-center pb-0 mb-0"> Emprunts Bibliothèques</h5>
  </div>

  <!-- Parite inferieur avec le groupe item -->
  <div class="row bodydashboard" *ngIf="appareilName == 'emprunts'">
    <ul class="list-group col-12 pr-0 overflow-auto mt-0 pt-0" style="max-height:14vh">
      <li class="list-group-item col-12  w-100 p-3 rounded-0"  *ngFor="let item of tab, let i = index">
        <a  href="#" id={{i}} data-toggle="modal" data-target="#EmpruntModal"  (click)="setId($event)"  style="color:black">{{tab[i].titre}} {{tab[i].auteur}} jusqu'au : {{tab[i].dateFinEmprunt}} </a>
      </li>
      
    </ul>
    <app-pop-up-info [info] = sendEmprunt(ind) [modalName] = "name1"></app-pop-up-info>
  </div>



  <div class="row justify-content-md-center en-tête pb-1 m-0"  style="min-height: 5vh;" *ngIf="appareilName == 'contact'">
    <h5 class="col-12 text-center pb-0 mb-0"> Contacts</h5>
  </div>

  <!-- Parite inferieur avec le groupe item -->
  <div class="row bodydashboard" *ngIf="appareilName == 'contact'">
    <ul class="list-group col-12 pr-0 overflow-auto mt-0 pt-0" style="max-height:30vh">
      <li class="list-group-item col-12  w-100 p-3 rounded-0"  *ngFor="let item of tab, let i = index"> 
        <a href="#" id={{i}} data-toggle="modal" data-target="#ContactModal"  (click)="setId($event)" style="color:black">{{tab[i].nom}} {{tab[i].prenom}}</a>
      </li>
      
    </ul>
    <app-pop-up-info [info] = sendContact(ind) [modalName] = "name2"></app-pop-up-info>
  </div>
